export const CONFIGURATION = {
    LOAD: 'CONFIGURATION/LOAD',
    LOAD_WIDGET: 'CONFIGURATION/LOAD/WIDGET',
    LOAD_POPUP: 'CONFIGURATION/LOAD/POPUP',
    LOAD_EIP: 'CONFIGURATION/LOAD/EIP',
    UPDATE_WIDGET: 'CONFIGURATION/UPDATE/WIDGET',
    RESET: 'CONFIGURATION/RESET',
    RESET_WIDGET: 'CONFIGURATION/RESET_WIDGET',
    RESET_POPUP: 'CONFIGURATION/RESET_POPUP',
    RESET_EIP: 'CONFIGURATION/RESET_EIP'
};

export const CONFIGURATION_TYPE = {
    WIDGET: 'CONFIGURATION/TYPE/WIDGET',
    POPUP: 'CONFIGURATION/TYPE/POPUP',
    EIP: 'CONFIGURATION/TYPE/EIP'
};
